/* eslint-disable no-debugger,no-unreachable */
import {calculaterouteRoutingV8} from "@/routing/api";
import {Waypoint} from "@/routing/services/waypoints";
import {TruckSetting} from "@/routing/services/truck-setting";
import {AvoidSetting} from "@/routing/services/avoid-setting";
import {parseRoutingV8Resp} from "@/routing/services/route";

export class RoutePlan {

  constructor(truckSetting, avoidSetting, transportMode) {
    this.truckSetting = truckSetting
    this.avoidSetting = avoidSetting
    this.routingMode = 'fast'
    this.transportMode = transportMode
    this.waypoints = []
    this.alternatives = null
    this.departureTime = null
  }

  addWaypoint(waypoint) {
    this.waypoints.push(waypoint)
  }

  getRoute(cancelToken) {
    const params = {
      apikey: process.env.VUE_APP_HERE_MAP_KEY,
      return: 'polyline,summary,actions,instructions,tolls',
      transportMode: this.transportMode,
      routingMode: this.routingMode,
      alternatives: this.alternatives,
      ...this.truckSetting.toQueryParams(),
      ...this.avoidSetting.toQueryParams(),
    }
    // waypoints 按顺序添加
    const paramStrings = []
    this.waypoints.forEach(wp => paramStrings.push(wp.toQueryParamString()))

    RoutePlan.KEYS.forEach(key => {
      if (this[key]) {
        params[key] = this[key]
      }
    })
    //
    return calculaterouteRoutingV8(params, paramStrings, cancelToken).then(({ res }) => {
      let data = res.data
      if (res.data.routes.length) {
        return parseRoutingV8Resp(res.data.routes)
      }
      return Promise.reject({ error: data.notices })
    })
  }

  static fromFleetParams(params) {
    let more = null
    let setting = []
    let routeSetting = params.routeSetting || []
    // truck mode
    if (params.mode === 'truck') {
      more = RoutePlan.TRANSPORT_MODE.TRUCK
      setting = routeSetting
    } else {
      more = RoutePlan.TRANSPORT_MODE.CAR
      // Avoiding difficult turns is only supported for transport mode `truck`
      setting = routeSetting.filter(item => item !== 'harshTurn')
    }
    // avoid setting
    const avoidSetting = new AvoidSetting(setting)
    // truck setting
    const truckSetting = new TruckSetting(params)
    
    const routePlan = new RoutePlan(truckSetting, avoidSetting, null)
    routePlan.alternatives = params.alternatives
    routePlan.departureTime = params.departure
    routePlan.transportMode = more

    // Waypoints
    let waypoint = params.wayPoints
    for (let i = 0; i < waypoint.length; i++) {
      let type = Waypoint.TYPE.VIA
      if (i === 0) {
        type = Waypoint.TYPE.START
      } else if (i === waypoint.length -1) {
        type = Waypoint.TYPE.STOP
      }
      
      routePlan.addWaypoint(new Waypoint(type, waypoint[i]))
    }
    return routePlan
  }
}
RoutePlan.TRANSPORT_MODE = {
  TRUCK: 'truck',
  CAR: 'car',
}
RoutePlan.KEYS = ['alternatives', 'departureTime']
